import { useLang } from '@/app/utils/useLang';
import styles from './index.module.scss';

const Disclaimer: React.FC = () => {
    const { t } = useLang('landingPage.disclaimer');
    return (
        <div className={styles.Disclaimer}>
            <p className="title">{t('title')}</p>
            <p className="desc">{t('desc')}</p>
        </div>
    );
};

export default Disclaimer;
